import React, { useState, useEffect } from 'react';

import { LeanUser, BusinessOutlaw } from 'models';
import { consoleLogInDev } from 'shared';
import { BasicDialog, TextButton } from 'library';
import { findByBusinessId } from 'api/BusinessOutlawsApi';
import { BusinessList, UserInfo } from 'internal/texting/outreach/ProviderOutlawModalComponents';
import { useHistory } from 'react-router';
import { banHandler, unBanHandler } from 'internal/texting/outreach/ProviderOutlawMethods';

export default function ExternalBusinessOutlawModal({
    user,
    businessId,
    refreshProviderList,
    open,
    onClose,
    leaveFeedback = true,
}: {
    user: LeanUser;
    businessId: number;
    refreshProviderList?: (provider: LeanUser, businessId?: number, businessLocationId?: number) => void;
    open: boolean;
    onClose: () => void;
    leaveFeedback?: boolean;
}) {
    const [outlawed, setOutlawed] = useState<BusinessOutlaw[]>([]);
    const history = useHistory();

    useEffect(() => {
        if (open && user.id && businessId) {
            findByBusinessId(user.id, businessId).then(setOutlawed).catch(consoleLogInDev);
        }
    }, [open]);

    function updateProviders(businessId?: number, locationId?: number) {
        refreshProviderList?.(user, businessId, locationId);
    }

    function banProvider(locationId: number, businessId: number) {
        banHandler(user.id, outlawed, locationId, businessId, setOutlawed, '', updateProviders);
    }

    function unBanProvider(providerOutlawId: number) {
        unBanHandler(providerOutlawId, outlawed, setOutlawed, updateProviders);
    }

    return (
        <>
            <BasicDialog
                dialogTitle={`Request not to book ${user.first_name}`}
                closeButton
                onClose={onClose}
                isOpen={open}
            >
                <UserInfo user={user} outlawed={outlawed} />
                <BusinessList
                    outlawed={outlawed}
                    banHandler={banProvider}
                    unBanHandler={unBanProvider}
                    showCreatedBy={false}
                />
                {leaveFeedback && (
                    <TextButton onClick={() => history.push(`providers/review/${user.id}`)}>
                        Leave feedback about {user.first_name}
                    </TextButton>
                )}
            </BasicDialog>
        </>
    );
}
